export const ListPlaceholder = () => (
    <ul className="list-group placeholder-glow">
        <li className="list-group-item placeholder py-4"></li>
        <li className="list-group-item placeholder py-4"></li>
        <li className="list-group-item placeholder py-4"></li>
        <li className="list-group-item placeholder py-4"></li>
        <li className="list-group-item placeholder py-4"></li>
    </ul>
);

export const TwoThirdsListPlaceholder = () => (
    <div className="g-col-12 g-col-lg-8">
        <ListPlaceholder />
    </div>
);
